import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import {
  patch,
  append,
  removeItem,
  insertItem,
  updateItem,
} from "@ngxs/store/operators";
import { setEmitFlags } from "typescript";
import {
  setToken,
  setLoginId,
  setCrmOppurtunityId,
  setAllDetails,
  setShow,
  setIsSmallDevice,
  setErrorMsg,
  setHideTimeline,
  setShowLoader,
  setSharedWithFinancer,
  setKycFetched,
  setDraft,
  setLost,
  setFinancer,
  setFinancers,
  setOtherOffers,
  setRecommendedOffers,
  setMoreOffers,
  setErrorStatus,
  setDisplayCounter,
  setRedirectionCheck,
  setHeaderTitle
} from "./app.action";
export class AppStoreModel {
  accessToken: any;
  loginId: any;
  crmOppurtunityId: any;
  allDetails: any;
  show: boolean = false;
  isSmallDevice: any;
  errorMsg: any;
  hideTimeline: boolean = true;
  showLoader: boolean = false;
  sharedWithFinancer: boolean = true;
  redirectionCheck: boolean = true;
  kycFetched: boolean = true;
  draft: boolean = true;
  lost: boolean = true;
  financer:any;
  financers:any;
  recommendedOffers:any;
  otherOffers:any;
  moreOffers:any;
  errorStatus:any;
  displayCounter:any;
  headerTitle: any;
}

@State<AppStoreModel>({
  name: "appStore",
  defaults: {
    accessToken: "",
    loginId: "",
    crmOppurtunityId: "",
    allDetails: null,
    show: false,
    isSmallDevice: false,
    errorMsg: "",
    hideTimeline: false,
    showLoader: false,
    sharedWithFinancer: true,
    redirectionCheck: true,
    kycFetched: true,
    draft: true,
    lost: true,
    financer:null,
    financers:null,
    recommendedOffers:[],
    otherOffers:[],
    moreOffers:[],
    errorStatus:null,
    displayCounter:null,
    headerTitle: ""
  },
})
@Injectable()
export class AppState {
  @Selector()
  static store(store: AppStoreModel) {
    return store;
  }

  @Selector()
  static accessToken({ accessToken }: AppStoreModel) {
    return accessToken;
  }
  static loginId({ loginId }: AppStoreModel) {
    return loginId;
  }

  static crmOppurtunityId({ crmOppurtunityId }: AppStoreModel) {
    return crmOppurtunityId;
  }

  static allDetails({ allDetails }: AppStoreModel) {
    return allDetails;
  }

  static headerTitle({ headerTitle }: AppStoreModel) {
    return headerTitle;
  }

  static show({ show }: AppStoreModel) {
    return show;
  }

  static isSmallDevice({ isSmallDevice }: AppStoreModel) {
    return isSmallDevice;
  }

  static errorMsg({ errorMsg }: AppStoreModel) {
    return errorMsg;
  }
  static hideTimeline({ hideTimeline }: AppStoreModel) {
    return hideTimeline;
  }
  static showLoader({ showLoader }: AppStoreModel) {
    return showLoader;
  }

  static sharedWithFinancer({ sharedWithFinancer }: AppStoreModel) {
    return sharedWithFinancer;
  }
  static redirectionCheck({ redirectionCheck }: AppStoreModel) {
    return redirectionCheck;
  }
  static kycFetched({ kycFetched }: AppStoreModel) {
    return kycFetched;
  }
  static draft({ draft }: AppStoreModel) {
    return draft;
  }
  static lost({ lost }: AppStoreModel) {
    return lost;
  }
  static financer({financer}:AppStoreModel){
    return financer
  }

  static financers({financers}:AppStoreModel){
    return financers
  }

  static recommendedOffers({recommendedOffers}:AppStoreModel){
    return recommendedOffers
  }

  static otherOffers({otherOffers}:AppStoreModel){
    return otherOffers
  }

  static moreOffers({moreOffers}:AppStoreModel){
    return moreOffers
  }

  static errorStatus({errorStatus}:AppStoreModel){
    return errorStatus
  }

  static displayCounter({displayCounter}:AppStoreModel){
    return displayCounter;
  }

  @Action(setToken)
  setToken(ctx: StateContext<AppStoreModel>, { payload }: setToken) {
    ctx.setState(
      patch({
        accessToken: payload,
      })
    );
  }

  @Action(setLoginId)
  setLoginId(ctx: StateContext<AppStoreModel>, { payload }: setLoginId) {
    ctx.setState(
      patch({
        loginId: payload,
      })
    );
  }

  @Action(setCrmOppurtunityId)
  setCrmOppurtunityId(
    ctx: StateContext<AppStoreModel>,
    { payload }: setCrmOppurtunityId
  ) {
    ctx.setState(
      patch({
        crmOppurtunityId: payload,
      })
    );
  }

  @Action(setAllDetails)
  setAllDetails(ctx: StateContext<AppStoreModel>, { payload }: setAllDetails) {
    ctx.setState(
      patch({
        allDetails: payload,
      })
    );
  }

  @Action(setHeaderTitle)
  setHeaderTitle(ctx: StateContext<AppStoreModel>, { payload }: setHeaderTitle) {
    ctx.setState(
      patch({
        headerTitle: payload,
      })
    );
  }

  @Action(setShow)
  setShow(ctx: StateContext<AppStoreModel>, { payload }: setShow) {
    ctx.setState(
      patch({
        show: payload,
      })
    );
  }

  @Action(setIsSmallDevice)
  setIsSmallDevice(
    ctx: StateContext<AppStoreModel>,
    { payload }: setIsSmallDevice
  ) {
    ctx.setState(
      patch({
        isSmallDevice: payload,
      })
    );
  }

  @Action(setErrorMsg)
  setErrorMsg(ctx: StateContext<AppStoreModel>, { payload }: setErrorMsg) {
    ctx.setState(
      patch({
        errorMsg: payload,
      })
    );
  }

  @Action(setErrorMsg)
  setHideTimeline(
    ctx: StateContext<AppStoreModel>,
    { payload }: setHideTimeline
  ) {
    ctx.setState(
      patch({
        hideTimeline: payload,
      })
    );
  }

  @Action(setShowLoader)
  setShowLoader(ctx: StateContext<AppStoreModel>, { payload }: setShowLoader) {
    ctx.setState(
      patch({
        showLoader: payload,
      })
    );
  }

  @Action(setSharedWithFinancer)
  setSharedWithFinancer(
    ctx: StateContext<AppStoreModel>,
    { payload }: setSharedWithFinancer
  ) {
    ctx.setState(
      patch({
        sharedWithFinancer: payload,
      })
    );
  }

  @Action(setRedirectionCheck)
  setRedirectionCheck(
    ctx: StateContext<AppStoreModel>,
    { payload }: setRedirectionCheck
  ) {
    ctx.setState(
      patch({
        redirectionCheck: payload,
      })
    );
  }

  @Action(setKycFetched)
  setKycFetched(
    ctx: StateContext<AppStoreModel>,
    { payload }: setKycFetched
  ) {
    ctx.setState(
      patch({
        kycFetched: payload,
      })
    );
  }


  @Action(setDraft)
  setDraft(
    ctx: StateContext<AppStoreModel>,
    { payload }: setDraft
  ) {
    ctx.setState(
      patch({
        draft: payload,
      })
    );
  }


  @Action(setLost)
  setLost(
    ctx: StateContext<AppStoreModel>,
    { payload }: setLost
  ) {
    ctx.setState(
      patch({
        lost: payload,
      })
    );
  }

  @Action(setFinancer)
  setFinancer(ctx: StateContext<AppStoreModel>, {payload}: setFinancer){
    ctx.setState(
      patch({
        financer:payload
      })
    )
  }

  @Action(setFinancers)
  setFinancers(ctx: StateContext<AppStoreModel>, {payload}: setFinancers){
    ctx.setState(
      patch({
        financers:payload
      })
    )
  }

  @Action(setRecommendedOffers)
  setRecommendedOffers(ctx: StateContext<AppStoreModel>, {payload}: setRecommendedOffers){
    ctx.setState(
      patch({
        recommendedOffers:payload
      })
    )
  }

  @Action(setOtherOffers)
  setOtherOffers(ctx: StateContext<AppStoreModel>, {payload}: setOtherOffers){
    ctx.setState(
      patch({
        otherOffers:payload
      })
    )
  }

  @Action(setMoreOffers)
  setMoreOffers(ctx: StateContext<AppStoreModel>, {payload}: setMoreOffers){
    ctx.setState(
      patch({
        moreOffers:payload
      })
    )
  }

  @Action(setErrorStatus)
  setErrorStatus(ctx: StateContext<AppStoreModel>, {payload}: setErrorStatus){
    ctx.setState(
      patch({
        errorStatus:payload
      })
    )
  }

  @Action(setDisplayCounter)
  setDisplayCounter(ctx: StateContext<AppStoreModel>, {payload}: setDisplayCounter){
    ctx.setState(
      patch({
        displayCounter:payload
      })
    )
  }
}
